import { z } from 'zod';
import { PERMISSIONS, ROLES } from '../permissions/index.ts';
import { uuidSchema } from './common.ts';

export const loginRequestSchema = z.strictObject({
  email: z.string().trim().min(3).max(254),
  password: z.string().min(1).max(256),
  /** The authenticator-app code; needed only when the account has two-factor authentication on. */
  otp: z
    .string()
    .regex(/^\d{6}$/)
    .optional(),
});

export const userSchema = z.strictObject({
  id: uuidSchema,
  displayName: z.string(),
  role: z.enum(ROLES),
  locale: z.enum(['uz-Latn', 'ru', 'en']),
  permissions: z.array(z.enum(PERMISSIONS)),
  /** The salesperson a `salesperson` account is scoped to; `null` for every other role. */
  salespersonId: uuidSchema.nullable(),
  twoFactorEnabled: z.boolean(),
});
export type UserDto = z.output<typeof userSchema>;

export const authResponseSchema = z.strictObject({ data: z.strictObject({ user: userSchema }) });

export const logoutResponseSchema = z.strictObject({
  data: z.strictObject({ loggedOut: z.literal(true) }),
});

export const twoFactorSetupResponseSchema = z.strictObject({
  data: z.strictObject({
    /** Base32 secret to type into an authenticator app. */
    secret: z.string(),
    /** `otpauth://` URI of the same secret (for apps and QR codes). */
    otpauthUri: z.string(),
  }),
});

export const twoFactorEnableRequestSchema = z.strictObject({
  code: z.string().regex(/^\d{6}$/),
});

export const twoFactorEnableResponseSchema = z.strictObject({
  data: z.strictObject({ enabled: z.literal(true) }),
});
